import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { SarlaftSecurityProps } from './props';
import { useSarlaftSecurity } from './hook';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import DatePickerField from '../../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import { useSarlaftForm } from '../hooks';

export const SarlaftSecurity = (props: SarlaftSecurityProps) => {
    const {
        formik,
        formikValidationCode,
        filtersValidation,
        statusValidation,
        isSuccessfulValidation,
        isLoadingSend,
        handleClickSend,
        isForwardDisabled,
        timeLeftForward,
    } = useSarlaftSecurity(props);

    const { sarlaft } = useSarlaftForm(props.account);
    const renderTimeLeftMessage = (timeLeftForward: any) => {
        if (timeLeftForward <= 0) return null;
        let mensaje = `El código se podrá reenviar en `;
        mensaje +=
            timeLeftForward >= 60
                ? ` ${Math.floor(timeLeftForward / 60)}:${
                    timeLeftForward % 60 < 10 ? '0' : ''
                }${timeLeftForward % 60} minutos`
                : ` ${timeLeftForward} segundos`;

        return (
            <Grid item xs={12}>
                <Typography style={{ color: 'grey' }} variant="subtitle2">
                    {mensaje}
                </Typography>
            </Grid>
        );
    };

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Seguridad Sarlaftt
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography style={{ color: '#000' }} variant="subtitle1">
                    Primer Filtro
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de nacimiento SISE"
                    name="birthDateSise"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.birthDateSise}
                    errors={formik.errors.birthDateSise?.toString()}
                    value={
                        formik.values.birthDateSise
                            ? dayjs(formik.values.birthDateSise)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'birthDateSise',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de nacimiento cliente"
                    name="birthDateClient"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.birthDateClient}
                    errors={formik.errors.birthDateClient?.toString()}
                    value={
                        formik.values.birthDateClient
                            ? dayjs(formik.values.birthDateClient)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'birthDateClient',
                            value ? value?.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(filtersValidation)}
                    label="Filtro fecha nacimiento"
                    name="filterBirthDate"
                    size="small"
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.filterBirthDate}
                    errors={formik.errors.filterBirthDate}
                    value={formik.values.filterBirthDate}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('filterBirthDate', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Edad SISE"
                    name="ageSise"
                    size="small"
                    touched={formik.touched.ageSise}
                    errors={formik.errors.ageSise}
                    value={formik.values.ageSise}
                    onChange={formik.handleChange}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Edad cliente"
                    name="ageClient"
                    size="small"
                    touched={formik.touched.ageClient}
                    errors={formik.errors.ageClient}
                    value={formik.values.ageClient}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(filtersValidation)}
                    label="Filtro edad"
                    name="filterAge"
                    size="small"
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.filterAge}
                    errors={formik.errors.filterAge}
                    value={formik.values.filterAge}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('filterAge', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(statusValidation)}
                    label="Estado validación"
                    name="statusValidation"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.statusValidation}
                    errors={formik.errors.statusValidation}
                    value={formik.values.statusValidation}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('statusValidation', value)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Observaciones"
                    name="observation"
                    size="small"
                    rows={3}
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                />
            </Grid>
            {isSuccessfulValidation && (
                <>
                    <Grid item xs={12}>
                        <Typography
                            style={{ fontWeight: 'bold', color: '#000' }}
                        >
                            Tip Informativo
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            style={{ color: '#000' }}
                            variant="subtitle2"
                        >
                            <p>Recuerde que: </p>
                            <ul>
                                <li>
                                    <strong>EL TOMADOR:</strong> Es quien figura
                                    como titular de la póliza y quien paga la
                                    prima.
                                </li>
                                <li>
                                    <strong>EL ASEGURADO:</strong> Es la persona
                                    a quien protege el seguro{' '}
                                    <em>(este puede ser el mismo TOMADOR).</em>
                                </li>
                                <li>
                                    <strong>EL BENEFICIARIO:</strong> Es aquel
                                    que recibirá la indemnización en caso de que
                                    ocurriera el siniestro{' '}
                                    <em>
                                        (este puede ser el mismo en todas las
                                        anteriores).
                                    </em>
                                </li>
                                <li>
                                    <strong>EL AFIANZADO:</strong> Es la misma
                                    figura del asegurado, pero únicamente en las
                                    pólizas de cumplimiento.
                                </li>
                                <li>
                                    <strong>INTERMEDIARIO Y PROVEEDOR:</strong>{' '}
                                    Únicamente aplica si posee vínculos
                                    laborales con la Previsora de Seguros.
                                </li>
                            </ul>
                        </Typography>
                    </Grid>
                    {/* Si es edición no se muestra el código OTP */}
                    {!sarlaft && (
                        <>
                            <Grid item xs={12}>
                                <Typography
                                    style={{ color: '#000' }}
                                    variant="subtitle1"
                                >
                                    Segundo Filtro
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButtonGeneral
                                    title={
                                        Boolean(formik.values.deliveryId)
                                            ? 'Validar Código OTP'
                                            : 'Generar Código OTP'
                                    }
                                    variant="outlined"
                                    onClick={
                                        Boolean(formik.values.deliveryId)
                                            ? formikValidationCode.handleSubmit
                                            : handleClickSend
                                    }
                                    loading={isLoadingSend}
                                    sx={{ mr: 1 }}
                                />
                                {formik.values.deliveryId && (
                                    <LoadingButtonGeneral
                                        title="Reenviar"
                                        variant="outlined"
                                        onClick={handleClickSend}
                                        loading={isLoadingSend}
                                        disabled={isForwardDisabled}
                                    />
                                )}
                                {timeLeftForward > 0 &&
                                    renderTimeLeftMessage(timeLeftForward)}
                            </Grid>
                            <Grid item xs={12} md={6} lg={4}>
                                <FieldText
                                    label="Código de verificación"
                                    name="verificationCode"
                                    size="small"
                                    touched={
                                        !formik.values.deliveryId
                                            ? formik.touched.verificationCode
                                            : formikValidationCode.touched
                                                .verificationCode
                                    }
                                    errors={
                                        !formik.values.deliveryId
                                            ? formik.errors.verificationCode
                                            : formikValidationCode.errors
                                                .verificationCode
                                    }
                                    value={
                                        !formik.values.deliveryId
                                            ? formik.values.verificationCode
                                            : formikValidationCode.values
                                                .verificationCode
                                    }
                                    onChange={
                                        !formik.values.deliveryId
                                            ? formik.handleChange
                                            : formikValidationCode.handleChange
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Checkbox
                                    label="Validación Código"
                                    disabled
                                    checked={Boolean(
                                        formik.values.validationCode
                                    )}
                                />
                            </Grid>
                        </>
                    )}
                </>
            )}
        </Grid>
    );
};
